import { withInstall } from '@mts-fe/utils';
import basicArrow from './src/BasicArrow.vue';
import basicHelp from './src/BasicHelp.vue';
import basicTitle from './src/BasicTitle.vue';

export const BasicArrow = withInstall(basicArrow);
export const BasicTitle = withInstall(basicTitle);
export const BasicHelp = withInstall(basicHelp);
